<template>
 
  <div v-if="!item.hidden&&item.name!='resource'">
    <template v-if="hasOneShowingChild(item.children,item) && (!onlyOneChild.children||onlyOneChild.noShowingChildren)&&!item.alwaysShow">
      <app-link v-if="onlyOneChild.meta" :to="resolvePath(onlyOneChild.path, onlyOneChild.query)">
        <el-menu-item :index="resolvePath(onlyOneChild.path)" :class="{'submenu-title-noDropdown':!isNest}">
          <i>
            <img :src="item.icon" alt="" style="margin-top: -5px;" v-if="this.$route.path!=item.path">
            <img :src="item.ficon" alt="" style="margin-top: -5px;" v-else>
          </i>
          <item :icon="onlyOneChild.meta.icon||(item.meta&&item.meta.icon)" :title="onlyOneChild.meta.title" />
        </el-menu-item>
      </app-link>
    </template>

    <el-submenu v-else ref="subMenu" :index="resolvePath(item.path)" popper-append-to-body >
      <template slot="title">
        <i>
          <!-- {{ item.path }} -->
          <img :src="item.icon" alt="" style="margin-top: -5px;" v-if="!this.$route.path.includes(item.path)">
          <img :src="item.ficon" alt="" style="margin-top: -5px;" v-else>
        </i>
        <item v-if="item.meta" :icon="item.meta && item.meta.icon" :title="item.meta.title" />
      </template>
      <sidebar-item
        v-for="(child, index) in item.children"
        :key="child.path + index"
        :is-nest="true"
        :item="child"
        :base-path="resolvePath(child.path)"
        class="nest-menu"
      />
    </el-submenu>
  </div>
</template>

<script>
import path from 'path'
import { checkStr } from '@/utils/toolUtils'
import Item from './item'
import AppLink from './Link'

export default {
  name: 'SidebarItem',
  components: { Item, AppLink },
  // mixins: [FixiOSBug],
  props: {
    // route object
    item: {
      type: Object,
      required: true
    },
    isNest: {
      type: Boolean,
      default: false
    },
    basePath: {
      type: String,
      default: '/'
    },
  },
  data() {
    this.onlyOneChild = null
    return {
      panduan:true
    }
  },
  methods: {
    hasOneShowingChild(children = [], parent) {
      if (!children) {
        children = [];
      }
      const showingChildren = children.filter(item => {
        // console.log(item);
        
        if (item.hidden) {
          return false
        } else {
          // Temp set(will be used if only has one showing child)
          this.onlyOneChild = item
          return true
        }
      })

      // When there is only one child router, the child router is displayed by default
      if (showingChildren.length === 1) {
        return true
      }

      // Show parent if there are no child router to display
      if (showingChildren.length === 0) {
        this.onlyOneChild = { ... parent, path: '', noShowingChildren: true }
        return true
      }

      return false
    },
    resolvePath(routePath, routeQuery) {
      if (checkStr(routePath, 'PATH')) {
        return routePath
      }
      if (checkStr(this.basePath, 'PATH')) {
        return this.basePath
      }
      if (routeQuery) {
        let query = JSON.parse(routeQuery);
        return { path: path.resolve(this.basePath, routePath), query: query }
      }
      return path.resolve(this.basePath, routePath)
    },
    // pinjie(path1,path2){
    //   console.log(path1+"/"+path2);
      
    //   return path1+"/"+path2
    // }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/sidebar/sidebar-item.vue